// extracted by mini-css-extract-plugin
export var modal = "_lg-0";